import { Form, InputNumber } from 'antd';

// The query API rate limit a cluster of this size starts with, per analytics pod. It is copied into a
// cluster when the cluster is created while the queryRateLimitMode system configuration is observe or
// enforce; existing clusters keep their own number, changed per cluster.
function QueryRateLimitFields() {
  return (
    <section className="capacity-drawer__section">
      <h3 className="capacity-drawer__heading">Query rate limit</h3>
      <div className="capacity-drawer__grid capacity-drawer__grid--2">
        <Form.Item
          name="queryRequestsPerMinute"
          label="Requests per minute per session, per analytics pod"
          extra="For /incorta/bff/v1/query. Copied into clusters created on this size while the query rate limit mode is observe or enforce: each session (signed-in user or API token) may then send this × the cluster's analytics pods per minute. Existing clusters keep their own number. Empty: new clusters of this size are not limited."
        >
          <InputNumber
            min={1}
            max={1000000}
            precision={0}
            placeholder="Not limited"
            addonAfter="/ min"
          />
        </Form.Item>
      </div>
    </section>
  );
}

export default QueryRateLimitFields;
